import Box from "@mui/material/Box";
import { useSelector } from "react-redux";

import CustomDrawer from "./CustomDrawer";
import { getAllDrawerState } from "../../redux/selectors/drawerSelectors";

function MainCustomDrawer() {
  const drawersState = useSelector(getAllDrawerState);

  return (
    <Box
      id="MainCustomDrawer"
      p={0}
      m={0}
      aria-label="drawers section"
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(2, minmax(60px, auto))",
        height: "100%",
        overflowY: "hidden"
      }}
    >
      {drawersState.partner?.shouldDisplay && (
        <CustomDrawer drawerTypeName="partner" />
      )}
      {drawersState.client?.shouldDisplay && (
        <CustomDrawer drawerTypeName="client" />
      )}
      {drawersState.site?.shouldDisplay && (
        <CustomDrawer drawerTypeName="site" />
      )}
    </Box>
  );
}

export default MainCustomDrawer;
